export default {
  namespaced: true,
  state: {
    isHq: false,
    selectedCompany: null,
    visitFields: [
      { id: 'company_name', field_name: 'Branch', enable: true, type: 'system' },
      { id: 'formatted_date', field_name: 'Visit date', enable: true, type: 'system' },
      { id: 'doctor_name', field_name: 'Doctor', enable: true, type: 'system' },
      { id: 'payment_methods', field_name: 'Payment method', enable: true, type: 'system' },
      { id: 'invoice', field_name: 'Payment status', enable: true, type: 'system' },
    ],
    billingFields: [
      { id: 'company_name', field_name: 'Branch', enable: true, type: 'system' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
      { id: 'invoice_no', field_name: 'Invoice no', enable: true, type: 'system', width: '120' },
      { id: 'payment', field_name: 'Payment method', enable: true, type: 'system' },
      { id: 'claim_status', field_name: 'Claim status', enable: true, type: 'system' },
      { id: 'record_date', field_name: 'Created date', enable: true, type: 'system', width: '140' },
    ],
    appointmentFields: [
      { id: 'company_name', field_name: 'Branch', enable: true, type: 'system' },
      { id: 'date', field_name: 'Date', enable: true, type: 'system', width: '125', sort_query_param: 'start__date' },
      { id: 'time', field_name: 'Schedule time', enable: true, type: 'system', width: '160', sort_query_param: 'start__time' },
      { id: 'services', field_name: 'Services', enable: true, type: 'system', sortable: false },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system', width: '180', sort_query_param: 'lead__member__user__first_name' },
      { id: 'paid', field_name: 'Payment', enable: true, type: 'system', sortable: false },
      { id: 'contacted', field_name: 'Sent Status', enable: true, type: 'system', sortable: false },
    ],
    appointmentScheduleFields: [
      { id: 'company_name', field_name: 'Branch', enable: true, type: 'system' },
      { id: 'services', field_name: 'Services', enable: true, type: 'system', sortable: false },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system', sortable: false },
      { id: 'total_sessions', field_name: 'Total Sessions', enable: true, type: 'system', sortable: false },
      { id: 'scheduled', field_name: 'Scheduled', enable: true, type: 'system', sortable: false },
      { id: 'pending', field_name: 'Dates Pending', enable: true, type: 'system', sortable: false },
    ],
    appointmentRequestFields: [
      { id: 'date', field_name: 'Date', enable: true, type: 'system', width: '125', sort_query_param: 'start__date' },
      { id: 'time', field_name: 'Schedule time', enable: true, type: 'system', width: '160', sort_query_param: 'start__time' },
      { id: 'services', field_name: 'Services', enable: true, type: 'system', sortable: false },
      { id: 'provider', field_name: 'Providers', enable: true, type: 'system', width: '180', sort_query_param: 'lead__member__user__first_name' },
    ],
    inventoryFields: [
      { id: 'category', field_name: 'Category', enable: true, type: 'system', sortable: false },
      { id: 'groups', field_name: 'Groups', enable: true, type: 'system', sortable: false, width: 200 },
      { id: 'costPrice', field_name: 'Cost & Price', enable: true, type: 'system', sortable: false, width: 200 },
      { id: 'stock', field_name: 'Stock', enable: true, type: 'system', sortable: false, width: 120 },
      { id: 'expiryDate', field_name: 'Expiry Date', enable: true, type: 'system', sortable: false },
      { id: 'location', field_name: 'Location', enable: true, type: 'system', sortable: false, width: 250 },
    ],
    servicesFields: [
      { id: 'type', field_name: 'Type', enable: true, type: 'system', sortable: false },
      { id: 'description', field_name: 'Description', enable: true, type: 'system', sortable: false },
      { id: 'cost', field_name: 'Cost', enable: true, type: 'system', sortable: false },
      { id: 'priceToPatient', field_name: 'Price to patient', enable: true, type: 'system', sortable: false },
      { id: 'branches', field_name: 'Branches', enable: true, type: 'system', sortable: false, width: 250 },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sortable: false },
    ],
    packagesFields: [
      { id: 'branches', field_name: 'Branches', enable: true, type: 'system', sortable: false },
      { id: 'stock', field_name: 'Stock', enable: true, type: 'system', sortable: true, sort_query_param: 'available_qty' },
      { id: 'price', field_name: 'Price', enable: true, type: 'system', sortable: true, sort_query_param: 'product__price' },
      { id: 'items', field_name: 'Items', enable: true, type: 'system', sortable: false },
      { id: 'status', field_name: 'Status', enable: true, type: 'system', sortable: false },
    ],
    inventoryListFields: [
      { id: 'name', field_name: 'Name', enable: true, type: 'system' },
      { id: 'total_item', field_name: 'Total item', enable: true, type: 'system' },
      { id: 'created', field_name: 'Created date', enable: true, type: 'system' },
      { id: 'order_freq', field_name: 'Order frequency', enable: true, type: 'system' },
      { id: 'remarks', field_name: 'Remarks', enable: true, type: 'system' },
    ],
    stocktakeFields: [
      { id: 'user', field_name: 'User', enable: true, type: 'system' },
      { id: 'inventory', field_name: 'Inventories', enable: true, type: 'system' },
      { id: 'start_date', field_name: 'Start date', enable: true, type: 'system' },
      { id: 'end_date', field_name: 'End date', enable: true, type: 'system' },
      { id: 'status', field_name: 'Status', enable: true, type: 'system' },
    ],
    storageLocationFields: [
      { id: 'created', field_name: 'Created date', enable: true, type: 'system' },
      { id: 'inventory', field_name: 'Inventories', enable: true, type: 'system' },
    ],
    branches: [],
    selectedAppointmentView: 'list',
    inventorySettings: null,
    inventoryCreationMode: null
  },
  mutations: {
    setIsHq(state, isHq) {
      state.isHq = isHq
    },
    setSelectedCompany(state, company) {
      state.selectedCompany = company
    },
    resetSelectedCompany(state) {
      state.selectedCompany = null
    },
    setSelectedAppointmentView(state, selection) {
      localStorage.setItem('yz_hq_selected_appointment_view', selection)
      state.selectedAppointmentView = selection
    },
    addBranch(state, data) {
      if (!state.branches.find(f => f.id === data.id)) {
        state.branches.push(data)
      }
    },
    resetBranches(state) {
      state.branches = []
    },
    setInventorySettings(state, settings) {
      state.inventorySettings = settings
    },
    setInventoryCreationMode(state, mode) {
      state.inventoryCreationMode = mode
    }
  },
  getters: {
    getIsHq(state) {
      return state.isHq
    },
    getSelectedCompany(state) {
      return state.selectedCompany
    },
    getVisitFields(state) {
      const fields = state.visitFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_visit_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getBillingFields(state) {
      const fields = state.billingFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_billing_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentFields(state) {
      const fields = state.appointmentFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_appointment_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentScheduleFields(state) {
      const fields = state.appointmentScheduleFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_appointment_schedule_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getAppointmentRequestFields(state) {
      const fields = state.appointmentRequestFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_appointment_request_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getInventoryFields(state) {
      const fields = state.inventoryFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_inventory_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getServicesFields(state) {
      const fields = state.servicesFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_services_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getPackagesFields(state) {
      const fields = state.packagesFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_packages_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getInventoryListFields(state) {
      const fields = state.inventoryListFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_inventory_list_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getStocktakeFields(state) {
      const fields = state.stocktakeFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_stocktake_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getStorageLocationFields(state) {
      const fields = state.storageLocationFields
      const savedFields = JSON.parse(localStorage.getItem('yz_hq_storage_location_fields'))
      if (savedFields) {
        fields.map((field) => {
          field.enable = savedFields.includes(field.id)
        })
      }
      return fields
    },
    getSelectedAppointmentView(state) {
      return state.selectedAppointmentView
    },
    getBranches(state) {
      return state.branches
    },
    getInventorySettings(state) {
      return state.inventorySettings
    },
    canOverridePrice(state) {
      if (!state.inventorySettings) return true
      return state.inventorySettings.can_override_price !== false
    },
    canOverrideSupplier(state) {
      if (!state.inventorySettings) return true
      return state.inventorySettings.can_override_supplier !== false
    },
    canCreateInventory(state) {
      if (!state.inventoryCreationMode) return true
      return state.inventoryCreationMode !== 'hq_only'
    }
  },
  actions: {
    fetchInventorySettings({ commit }, { axios, hqId }) {
      return axios.get(`/companies/${hqId}/settings`, {
        params: { name: 'hq.branches.inventory_settings' }
      })
        .then(resp => {
          const results = resp.data?.results
          if (results && results.length > 0) {
            const permissions = results[0].extra_data?.branch_product_control_permissions || {}
            commit('setInventorySettings', permissions)
            const creationMode = results[0].extra_data?.inventory_creation_permissions?.mode
            if (creationMode) {
              commit('setInventoryCreationMode', creationMode)
            }
          }
        })
        .catch(() => {})
    }
  },
}